/*
 */
'use strict';

/*
 *
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Entry.FieldOutput = /*#__PURE__*/function (_Entry$Field) {
  function FieldOutput(content, blockView, index, mode, contentIndex) {
    var _this;
    (0, _classCallCheck2["default"])(this, FieldOutput);
    _this = _callSuper(this, FieldOutput, [content, blockView, index]);
    (0, _defineProperty2["default"])(_this, "schema", {
      magneting: false
    });
    Entry.Model(_this, false);
    _this._blockView = blockView;
    _this._block = blockView.block;
    _this._valueBlock = null;
    _this.box = new Entry.BoxModel();
    _this.changeEvent = new Entry.Event(_this);
    _this._index = index;
    _this.contentIndex = contentIndex;
    _this._content = content;
    _this.acceptType = content.accept;
    _this.view = _this;
    _this.svgGroup = null;
    _this._position = content.position;
    _this.box.observe(blockView, 'dAlignContent', ['width', 'height']);
    _this.observe(_this, '_updateBG', ['magneting'], false);
    _this.renderStart(blockView.getBoard(), mode);
    _this.isParamBlockType = _.constant(true);
    _this.calcHeight = _this.calcWH;
    return _this;
  }
  (0, _inherits2["default"])(FieldOutput, _Entry$Field);
  return (0, _createClass2["default"])(FieldOutput, [{
    key: "renderStart",
    value: function renderStart(board, mode) {
      if (!this.svgGroup) {
        this.svgGroup = this._blockView.contentSvgGroup.elem('g');
      }
      this.view = this;
      this._nextGroup = this.svgGroup;
      var block = this.getValue();
      if (block && !block.view) {
        block.setThread(this);
        block.createView(board, mode);
      }
      this._updateValueBlock(block);
      this._valueBlock && this._valueBlock.view._startContentRender(this.renderMode);
      if (this._blockView.getBoard().constructor == Entry.BlockMenu && this._valueBlock) {
        this._valueBlock.view.removeControl();
      }
    }
  }, {
    key: "align",
    value: function align(x, y, animate) {
      animate = animate === undefined ? true : animate;
      var svgGroup = this.svgGroup;
      if (this._position) {
        if (this._position.x) {
          x = this._position.x;
        }
        if (this._position.y) {
          y = this._position.y;
        }
      }
      var block = this._valueBlock;
      if (block && block.view) {
        y = block.view.height * -0.5;
      }
      var transform = "translate(".concat(x, ",").concat(y, ")");
      if (animate) {
        svgGroup.animate({
          transform: transform
        }, 300, mina.easeinout);
      } else {
        svgGroup.attr({
          transform: transform
        });
      }
      if (this.box.x !== x || this.box.y !== y) {
        this.box.set({
          x: x,
          y: y
        });
      }
    }
  }, {
    key: "calcWH",
    value: function calcWH() {
      var block = this._valueBlock;
      var blockView = block && block.view;
      if (block && blockView) {
        if (this.box.width !== blockView.width || this.box.height !== blockView.height) {
          this.box.set({
            width: blockView.width,
            height: blockView.height
          });
        }
      } else {
        this.box.set({
          width: 0,
          height: 20
        });
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._valueBlock && this._valueBlock.destroyView();
    }
  }, {
    key: "_inspectBlock",
    value: function _inspectBlock() {}
  }, {
    key: "_setValueBlock",
    value: function _setValueBlock(block) {
      if (block != this._valueBlock || !this._valueBlock) {
        this._valueBlock = block;
        this.setValue(block);
        block && block.setThread(this);
        return this._valueBlock;
      }
    }
  }, {
    key: "spliceBlock",
    value: function spliceBlock() {
      this._updateValueBlock();
    }
  }, {
    key: "_updateValueBlock",
    value: function _updateValueBlock(block) {
      if (!(block instanceof Entry.Block)) {
        block = undefined;
      }
      if (block && block === this._valueBlock) {
        this.calcWH();
        return;
      }
      this._sizeObserver && this._sizeObserver.destroy();
      this._posObserver && this._posObserver.destroy();
      block = this._setValueBlock(block);
      if (block) {
        var view = block.view;
        view.bindPrev();
        this._posObserver = view.observe(this, '_updateValueBlock', ['x', 'y'], false);
        this._sizeObserver = view.observe(this, 'calcWH', ['width', 'height']);
      } else {
        this.calcWH();
      }
      this._blockView.dAlignContent();
    }
  }, {
    key: "getPrevBlock",
    value: function getPrevBlock(block) {
      if (this._valueBlock === block) {
        return this;
      } else {
        return null;
      }
    }
  }, {
    key: "getNextBlock",
    value: function getNextBlock() {
      return null;
    }
  }, {
    key: "requestAbsoluteCoordinate",
    value: function requestAbsoluteCoordinate(blockView) {
      var board = this.getBoard();
      var _ref = board || {},
        _ref$scale = _ref.scale,
        scale = _ref$scale === void 0 ? 1 : _ref$scale;
      var blockView = this._blockView;
      var contentPos = blockView.contentPos;
      var pos = blockView.getAbsoluteCoordinate();
      pos.x += (this.box.x + contentPos.x) * scale;
      pos.y += this.box.y + contentPos.y;
      return pos;
    }
  }, {
    key: "dominate",
    value: function dominate() {
      this._blockView.dominate();
    }
  }, {
    key: "isGlobal",
    value: function isGlobal() {
      return false;
    }
  }, {
    key: "separate",
    value: function separate(block) {
      this.getCode().createThread([block]);
      this._updateValueBlock(null);
      this.changeEvent.notify();
    }
  }, {
    key: "getCode",
    value: function getCode() {
      return this._block.thread.getCode();
    }
  }, {
    key: "cut",
    value: function cut(block) {
      if (this._valueBlock === block) {
        delete this._valueBlock;
        return [block];
      } else {
        return null;
      }
    }
  }, {
    key: "_updateBG",
    value: function _updateBG() {
      if (this.magneting) {
        this._bg = this.svgGroup.elem('path', {
          d: 'm -4,-12 h 3 l 2,2 0,3 3,0 1,1 0,12 -1,1 -3,0 0,3 -2,2 h -3 ',
          fill: '#fff',
          stroke: '#fff',
          'fill-opacity': 0.7,
          transform: "translate(0,".concat(this._valueBlock ? 12 : 0, ")")
        });
      } else {
        if (this._bg) {
          this._bg.remove();
          delete this._bg;
        }
      }
    }
  }, {
    key: "replace",
    value: function replace(block) {
      var valueBlock = this._valueBlock;
      if (valueBlock) {
        valueBlock.view._toGlobalCoordinate();
        block.getTerminateOutputBlock().view._contents[1].replace(valueBlock);
      }
      this._updateValueBlock(block);
      block.view._toLocalCoordinate(this);
      this.calcWH();
    }
  }, {
    key: "setParent",
    value: function setParent(parent) {
      this._parent = parent;
    }
  }, {
    key: "getParent",
    value: function getParent() {
      return this._parent;
    }
  }, {
    key: "getThread",
    value: function getThread() {
      return this;
    }
  }, {
    key: "getValueBlock",
    value: function getValueBlock() {
      return this._valueBlock;
    }
  }, {
    key: "pointer",
    value: function pointer(_pointer) {
      _pointer = _pointer || [];
      _pointer.unshift(this._index);
      _pointer.unshift(Entry.PARAM);
      return this._block.pointer(_pointer);
    }
  }]);
}(Entry.Field);